<template>
  <div>
    <v-btn
      @click="languageChange('hu')"
      class="ma-1 float-right"
      :color="`${dark ? 'white' : ''}`"
      outlined
      elevation="0"
      >hu</v-btn
    >
    <v-btn
      @click="languageChange('en')"
      class="ma-1 float-right"
      :color="`${dark ? 'white' : ''}`"
      outlined
      elevation="0"
      >en</v-btn
    >
  </div>
</template>
<script>
export default {
  name: "LangSelector",
  props: {
    dark: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data: () => ({}),
  methods: {
    languageChange(lang) {
      const currentPath = this.$route.params.lang

      if (currentPath === lang) return;
      this.$store.commit("setLanguage", lang);
      if (!currentPath) return;
      this.$router.replace({ path: this.$route.path.replace(`/${currentPath}`, `/${lang}`) });
    },
  },
};
</script>